var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgHouse(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.946 19.543a.398.398 0 00-.021-.103l-.013-.037a.4.4 0 00-.08-.117l-6.387-6.387a.4.4 0 00-.28-.117h-8.61a2.35 2.35 0 00.227-.998 2.399 2.399 0 00-2.008-2.364 2.395 2.395 0 10-4.764 0 2.383 2.383 0 00-1.619 3.661 2.37 2.37 0 00.06 2.695 2.373 2.373 0 00.177 2.999l-.51.51a.4.4 0 00-.118.283v7.983c0 .22.18.4.4.4h23.15a.4.4 0 00.4-.4v-7.983c0-.009-.005-.016-.005-.025zm-6.947-5.963l5.588 5.589h-9.249L11.75 13.58H21zm-15.807-.758a1.58 1.58 0 01-.393-1.038c0-.882.715-1.597 1.596-1.597.03.004.057.007.084.008a.4.4 0 00.402-.519 1.583 1.583 0 01-.086-.487 1.597 1.597 0 013.193 0c-.003.166-.032.33-.085.487a.4.4 0 00.401.519.652.652 0 00.083-.008c.882 0 1.597.715 1.597 1.597 0 .364-.128.717-.36.998h-.838a.4.4 0 00-.136.026c-.005.002-.01 0-.015.004a.15.15 0 01-.022.014.398.398 0 00-.089.06c-.006.004-.014.007-.02.013L8.79 14.612v-4.225a.4.4 0 00-.798 0v2.23l-.915-.916a.4.4 0 00-.565.565l1.48 1.48v1.664l-.399.4-.516-.516a.4.4 0 00-.565.564l.517.516-1.839 1.837a1.57 1.57 0 01-.391-1.038c0-.419.164-.82.458-1.118a.4.4 0 000-.559 1.578 1.578 0 01-.065-2.155.4.4 0 000-.52zm7.191 14.33H9.19v-4.79h3.193v4.79zm4.39 0h-3.592v-5.19a.4.4 0 00-.399-.398H8.79a.4.4 0 00-.399.399v5.189H4.8v-7.419l.686-.687 3.188-3.187 2.113-2.114 5.988 5.988v7.419zm10.38 0h-9.58v-7.185h9.58v7.185z"
  }));
}

export default SvgHouse;